import config from '../../../config'
import development from './development'
import production from './production'

const env = config.env || 'development'

const targetRoot = env === 'development' ? development : production

export default targetRoot
